import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';

import { ProjectTypeRenderer } from '../../models/ProjectType';
import styled, { keyframes } from '../../theme';
import { projectTypeColorMap } from '../../components/ProjectTypeNav';

type IProps = {
  projectType: string;
} & RouteComponentProps<{
  projectType: string;
}>;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-5%);
  }

  to {
    opacity: 1;
    transform: none;
  }
`;

const Container = styled.div`
  padding: 50px 0;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
`;

const Description = styled.div`
  line-height: 1.5;
  position: relative;
  padding: 40px 0;
  margin: 0 auto;
  animation-name: ${fadeIn};
  animation-fill-mode: forwards;
  animation-duration: 0.8s;
  animation-timing-function: ease;
  opacity: 0;
  animation-delay: 0.4s;

  @media (min-width: ${(props) => props.theme.mobileBreakpoint}px) {
    width: 40%;
  }

  @media (max-width: ${(props) => props.theme.mobileBreakpoint - 1}px) {
    padding: ${(props) => props.theme.mobilePadding}px;
  }

  @media (min-width: ${(props) => props.theme.mobileBreakpoint}px) {
    text-align: center;
  }

  @media (min-width: 1800px) {
    font-size: 0.8vw;
  }
`;

const marquee = keyframes`
  from {
    transform: translateX(100vw) translateY(-50%);
  }

  to {
    transform: translateX(-100%) translateY(-50%);
  }
`;
const HeaderMarquee = styled.div`
  position: absolute;
  top: 50%;
  animation-name: ${marquee};
  animation-iteration-count: infinite;
  animation-duration: 20s;
  animation-timing-function: linear;
  font-size: 180px;
  white-space: nowrap;
  left: 0;
  letter-spacing: -13px;
  opacity: 0.18;
`;

class Header extends React.Component<IProps> {
  shouldComponentUpdate(nextProps: IProps) {
    return (
      nextProps.match.params.projectType !== this.props.match.params.projectType
    );
  }

  render() {
    return (
      <Container key={this.props.match.params.projectType}>
        <ProjectTypeRenderer
          render={({ typeMap }) => {
            const item = typeMap.get(this.props.projectType);
            if (!item) {
              return null;
            }

            return (
              <>
                <HeaderMarquee
                  style={{
                    color: `rgb(${projectTypeColorMap[item.fields.slug]})`,
                  }}
                >
                  {item.fields.name}Projects
                </HeaderMarquee>

                <Description>{item.fields.description}</Description>
              </>
            );
          }}
        />
      </Container>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/scenes/Project/Header.tsx